
import Vue from 'vue';
import { ModalActions, Button } from '@descomplica/vue-components';
import { ENDPOINTS } from '@/settings/endpoints';
import { CourseModel, UserModel } from '@descomplica/dex-models';
import LineCardSkeleton from '../../../../skeletons/atoms/LineSkeleton.vue';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { AlumniProfileModel } from '@/models/alumni-profile/alumni-profile.model';

interface Data {
  isFetchingUserName: boolean;
}

export default Vue.extend({
  components: {
    ModalActions,
    Button,
    LineCardSkeleton,
  },
  props: {
    showNameCheckingModal: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      isFetchingUserName: false,
    };
  },
  computed: {
    currentUserName(): string {
      const alumniProfile: AlumniProfileModel = this.$store.getters.currentAlumniProfile;

      return alumniProfile.firstName.concat(' ', alumniProfile.lastName).trim();
    },
    currentUser(): UserModel {
      return this.$store.getters.currentUser;
    },
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    alumniProfileEditorRoute(): string {
      return `${ENDPOINTS.alumni}/editar`;
    },
  },
  watch: {
    showNameCheckingModal(value: boolean) {
      if (value) {
        this.fetchUserName();

        Analytics.trackEvent(EVENT_LABELS.modalViewed, {
          course: this.currentCourse.name,
          postgrad_microcertificate_name_checking_modal: true,
        });
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.fetchUserName);
  },
  methods: {
    async fetchUserName(): Promise<void> {
      this.isFetchingUserName = true;
      await this.$store.dispatch('GET_ALUMNI_PROFILE', this.currentUser);
      this.isFetchingUserName = false;
    },

    openAlumniProfileEditor(): void {
      this.trackUpdateProfile();

      window.open(this.alumniProfileEditorRoute, '_blank');
      // enables autofetching when user returns to Classrooms tab
      window.addEventListener('focus', this.fetchUserName);
    },

    toggleNameSkeleton(): void {
      this.isFetchingUserName = !this.isFetchingUserName;
    },

    fetchMicrocertificateUrls(): void {
      this.$emit('fetchUrls');
    },

    trackUpdateProfile() {
      Analytics.trackEvent(EVENT_LABELS.linkNavigated, {
        postgrad_microcertificate_name_checking_modal: true,
        postgrad_microcertificate_name_checking_modal_action: 'update_profile',
        course: this.currentCourse.name,
      });
    },
  },
});
